import React from 'react';
import * as S from './style';

const TablePopper = props => {
  return <S.TablePopper {...props} />;
};

export { TablePopper };
